/* eslint-disable @typescript-eslint/no-explicit-any */
import taipeiImage1 from "../../assets/images/Image_26.png";
import taipeiImage2 from "../../assets/images/Image_27.png";
import taipeiImage3 from "../../assets/images/Image_28.png";
import taipeiImage4 from "../../assets/images/Image_29.png";
import taipeiImage5 from "../../assets/images/Image_30.png";
import taipeiImage6 from "../../assets/images/Image_31.png";
import taipeiImage7 from "../../assets/images/Image_32.png";
import taipeiImage8 from "../../assets/images/Image_33.png";
import taipeiImage9 from "../../assets/images/Image_34.png";
import taipeiImage10 from "../../assets/images/Image_35.png";
import taipeiImage11 from "../../assets/images/Image_36.png";
import taipeiImage12 from "../../assets/images/Image_37.png";
import taipeiImage13 from "../../assets/images/Image_38.png";
import Carousel from "../Carousel";

const slides = [
  { image: taipeiImage1, caption: "At Taipei, Faculty for International Conference in 2009" },
  { image: taipeiImage2, caption: "Dr. Ashok Omray delivering talk in FDD Conclave at Hyderabad, June 2019" },
  { image: taipeiImage3, caption: "Dr. Ashok Omray, guest of honour, Columbia Institute of Pharmacy" },
  { image: taipeiImage4, caption: "Keynote speaker Dr. Ashok Omray at an International Conference in Bareilly, November 2019" },
  { image: taipeiImage5, caption: "Stalwart award for Pharma Research, 2018" },
  { image: taipeiImage6, caption: "Invited speaker Dr. Ashok Omray in Tokyo for Biological Conference 2010" },
  { image: taipeiImage7, caption: "Paperclip after International conference in Bareilly 2019" },
  { image: taipeiImage8, caption: "At IPC, Ahmedabad 2009" },
  { image: taipeiImage9, caption: "Felicitation of Dr. Smita Rajput from Merck at Poona College of Pharmacy, 2024" },
  { image: taipeiImage10, caption: "Lecture to Pharmacy students on Regulatory Affairs, 2024" },
  { image: taipeiImage11, caption: "Guest speaker Dr. Sagar Vichare at Poona College of Pharmacy, 2024" },
  { image: taipeiImage12, caption: "Chem-Expo Exhibition April 2024" },
  { image: taipeiImage13, caption: "Chem-Expo Exhibition April 2024" },
];

const RenownedCard = ({ slide }:{ slide:any }) => (
  <div className="flex flex-col items-center text-center rounded p-1 h-60">
    <img
      src={slide.image}
      alt={slide.caption}
      className="w-40 h-40 object-cover rounded"
    />
    <p className="text-sm text-[#05326D] mt-2">{slide.caption}</p>
  </div>
);

const Renowned = () => {
  
const renownedCards = slides.map((slide, index) => (
    <RenownedCard key={index} slide={slide} />
  ));

  return (
    <Carousel
      title="Our Top Renowned Resonance..."
      itemsPerPageConfig={{
        mobile: 1,
        tablet: 2,
        desktop: 4,
        large: 6
      }}
      backgroundColor="bg-[#ffffff]"
      showArrows={true}
      showDots={true}
      gap="gap-1"
      className="py-24"
    >
      {renownedCards}
    </Carousel>
  );
};

export default Renowned;
